import React from "react";
import { Button as MuiButton, ButtonProps, useTheme } from "@mui/material";
import { tokens } from "../../theme";

interface Props extends ButtonProps {
  label?: string;
}

const Button: React.FC<Props> = ({ label, children, ...props }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MuiButton
      sx={{
        borderRadius: 2,
        fontWeight: "bold",
        textTransform: "none",
        px: 3,
        ...props.sx,
        backgroundColor: colors.primary[400],
        color: colors.primary[900],
      }}
      {...props}
    >
      {label || children}
    </MuiButton>
  );
};

export default Button;
